<template>
    <a v-if="href" :href="href" class="mimer-button">{{ text }}</a>
    <button v-else class="mimer-button">{{ text }}</button>
</template>

<script>
export default {
    name: "MimerButton",
    props: {
        text: String,
        href: {
            type: String,
            default: undefined,
        },
    },
};
</script>

<style>
.mimer-button {
    border-radius: 0.25rem;
    border-style: none;
    display: block;
    font-size: 1rem;
    line-height: 1.5rem;
    max-width: 32rem;
    padding: 1rem;
    text-align: center;
    color: white;
    width: 100%;
    background-color: #951b81;
    font-family: system, Segoe UI, Tahoma, -apple-system;
    cursor: pointer;
}
.mimer-button:hover {
    opacity: 0.9;
}
</style>
